module.exports = __webpack_public_path__ + "static/media/umbrella-beach.5b9871fe.svg";